import { ROUTES_PATH } from 'app/constants/Routes';
import { registerCommunityAccess } from './api';

export function isCommunityLink(url?: string): boolean {
  return url === ROUTES_PATH.EXTERNAL.COMUNIDADE;
}

export function openCommunity(): void {
  registerCommunityAccess().catch(() => undefined);

  const communityWindow = window.open(
    ROUTES_PATH.EXTERNAL.COMUNIDADE,
    '_blank',
    'noopener,noreferrer',
  );

  if (communityWindow) {
    communityWindow.opener = null;
  }
}
